var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWattlordLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 47,
    viewBox: "0 0 113 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1935 14.1046L61.5669 3.52615H61.6075L64.9809 14.1046H67.4601L71.6666 0H68.9436L66.0986 10.3593H66.0579L62.9487 0H60.307L57.1368 10.3593H57.0962L54.3122 0H51.5078L55.7143 14.1046H58.1935ZM75.6973 14.1046L76.9979 10.8773H83.2366L84.5778 14.1046H87.5041L81.306 0H79.091L72.832 14.1046H75.6973ZM77.875 8.72575H82.3457L80.1307 2.98828L77.875 8.72575ZM94.6265 14.1046V2.1914H99.0362V0H87.6562V2.1914H92.066V14.1046H94.6265ZM107.619 2.1914V14.1046H105.058V2.1914H100.648V0H112.028V2.1914H107.619Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7252 33.4781C72.8497 33.4781 73.8861 33.2954 74.8344 32.9302C75.7827 32.565 76.6024 32.0536 77.2933 31.3962C77.9842 30.7388 78.5227 29.9552 78.9088 29.0455C79.295 28.1357 79.488 27.1296 79.488 26.0273C79.488 24.8984 79.295 23.8791 78.9088 22.9693C78.5227 22.0596 77.9842 21.2859 77.2933 20.6484C76.6024 20.0109 75.7827 19.5195 74.8344 19.1742C73.8861 18.8289 72.8497 18.6562 71.7252 18.6562C70.6143 18.6562 69.5881 18.8289 68.6466 19.1742C67.705 19.5195 66.8921 20.0109 66.208 20.6484C65.5238 21.2859 64.9887 22.0596 64.6026 22.9693C64.2165 23.8791 64.0234 24.8984 64.0234 26.0273C64.0234 27.1296 64.2165 28.1357 64.6026 29.0455C64.9887 29.9552 65.5238 30.7388 66.208 31.3962C66.8921 32.0536 67.705 32.565 68.6466 32.9302C69.5881 33.2954 70.6143 33.4781 71.7252 33.4781ZM62.1655 33.1202V30.889H56.0488V19.0156H53.4883V33.1202H62.1655ZM69.7411 30.838C70.344 31.097 71.0112 31.2265 71.7428 31.2265C72.4744 31.2265 73.145 31.097 73.7546 30.838C74.3642 30.5791 74.8892 30.2171 75.3295 29.7523C75.7698 29.2875 76.1085 28.7396 76.3456 28.1088C76.5827 27.4779 76.7012 26.784 76.7012 26.0269C76.7012 25.2965 76.5827 24.6191 76.3456 23.9949C76.1085 23.3707 75.7732 22.8262 75.3397 22.3613C74.9061 21.8965 74.3846 21.5312 73.7749 21.2656C73.1653 21 72.4879 20.8672 71.7428 20.8672C70.9977 20.8672 70.3237 21 69.7208 21.2656C69.1179 21.5312 68.5997 21.8965 68.1662 22.3613C67.7327 22.8262 67.3974 23.3707 67.1603 23.9949C66.9232 24.6191 66.8047 25.2965 66.8047 26.0269C66.8047 26.784 66.9232 27.4779 67.1603 28.1088C67.3974 28.7396 67.7361 29.2875 68.1764 29.7523C68.6167 30.2171 69.1383 30.5791 69.7411 30.838ZM85.9785 33.1202V27.1437H87.848L91.1807 33.1202H94.2696L90.4288 26.8648C91.4449 26.639 92.2476 26.2041 92.8369 25.5599C93.4262 24.9158 93.7209 24.0824 93.7209 23.0597C93.7209 22.316 93.5719 21.6851 93.2738 21.1672C92.9758 20.6492 92.5795 20.2309 92.085 19.9121C91.5905 19.5934 91.0249 19.3643 90.3882 19.2248C89.7515 19.0854 89.0944 19.0156 88.417 19.0156H83.418V33.1202H85.9785ZM85.9766 25.0894H88.0697C88.4354 25.0894 88.8012 25.0629 89.167 25.0097C89.5328 24.9566 89.8613 24.857 90.1526 24.7109C90.4439 24.5648 90.6843 24.3556 90.874 24.0834C91.0637 23.8111 91.1585 23.4625 91.1585 23.0375C91.1585 22.6523 91.0705 22.3369 90.8943 22.0912C90.7182 21.8455 90.4947 21.6496 90.2237 21.5035C89.9528 21.3574 89.6446 21.2578 89.2991 21.2047C88.9536 21.1516 88.6183 21.125 88.2932 21.125H85.9766V25.0894ZM102.749 33.1202C103.684 33.1202 104.625 32.9841 105.574 32.7118C106.522 32.4396 107.376 32.0179 108.134 31.4468C108.893 30.8757 109.509 30.1453 109.984 29.2554C110.458 28.3656 110.695 27.3031 110.695 26.0679C110.695 24.7398 110.458 23.6275 109.984 22.731C109.509 21.8346 108.893 21.1107 108.134 20.5596C107.376 20.0084 106.522 19.6133 105.574 19.3742C104.625 19.1352 103.684 19.0156 102.749 19.0156H97.6484V33.1202H102.749ZM100.211 30.9257H102.345C103.009 30.9257 103.672 30.8494 104.336 30.6966C105 30.5439 105.599 30.2849 106.135 29.9197C106.67 29.5545 107.107 29.0597 107.445 28.4355C107.784 27.8113 107.953 27.0211 107.953 26.0648C107.953 25.0554 107.784 24.232 107.445 23.5945C107.107 22.957 106.67 22.459 106.135 22.1004C105.599 21.7418 105 21.4961 104.336 21.3633C103.672 21.2305 103.009 21.1641 102.345 21.1641H100.211V30.9257Z",
    fill: "url(#paint0_linear_1_23617)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.66832 46.9238C0.470926 47.0423 0.293271 47.0226 0.135356 46.8646C-0.0225593 46.7066 -0.0422987 46.5289 0.0761377 46.3315V38.5121C0.0366589 38.4331 0.0169195 38.3343 0.0169195 38.2159C0.0169195 38.1369 0.0366589 38.0382 0.0761377 37.9197V30.1003C0.0366589 30.0213 0.0169195 29.9226 0.0169195 29.8041C0.0169195 29.7251 0.0366589 29.6264 0.0761377 29.5079V21.6885C0.0366589 21.6095 0.0169195 21.5305 0.0169195 21.4515C0.0169195 21.3331 0.0366589 21.2343 0.0761377 21.1553V13.2767C0.0366589 13.2372 0.0169195 13.1582 0.0169195 13.0397C0.0169195 12.9213 0.0366589 12.8225 0.0761377 12.7436V4.92415C-0.0422987 4.72669 -0.00281992 4.52923 0.194574 4.33177L4.33985 0.185118C4.53724 -0.0123412 4.73464 -0.0518332 4.93203 0.0666427H12.8673C13.3805 0.0666427 13.5384 0.264102 13.341 0.659022V8.47843C13.3805 8.55741 13.4002 8.65614 13.4002 8.77462C13.4002 8.89309 13.3805 8.99182 13.341 9.07081V16.8902C13.3805 16.9692 13.4002 17.0679 13.4002 17.1864C13.4002 17.3049 13.3805 17.4036 13.341 17.4826V25.302C13.3805 25.381 13.4002 25.4797 13.4002 25.5982C13.4002 25.6772 13.3805 25.7759 13.341 25.8944V33.6545H16.8941V30.1003C16.8152 30.0213 16.7954 29.9226 16.8349 29.8041C16.7954 29.7251 16.8152 29.6264 16.8941 29.5079V21.6885C16.7757 21.5305 16.8152 21.3331 17.0126 21.0961L21.0986 17.0087C21.3355 16.8112 21.5329 16.7717 21.6908 16.8902H29.6852C30.1985 16.8902 30.3564 17.0877 30.159 17.4826V25.302C30.1985 25.381 30.2182 25.4698 30.2182 25.5686C30.2182 25.6673 30.1985 25.7759 30.159 25.8944V33.6545H33.6529V30.1003C33.6134 30.0213 33.5937 29.9226 33.5937 29.8041C33.5937 29.7251 33.6134 29.6264 33.6529 29.5079V21.6885C33.6134 21.6095 33.5937 21.5305 33.5937 21.4515C33.5937 21.3331 33.6134 21.2343 33.6529 21.1553V13.2767C33.6134 13.2372 33.5937 13.1582 33.5937 13.0397C33.5937 12.9213 33.6134 12.8225 33.6529 12.7436V4.92415C33.5344 4.72669 33.5739 4.52923 33.7713 4.33177L37.9166 0.185118C38.114 -0.0123412 38.3114 -0.0518332 38.5088 0.0666427H46.444C46.9572 0.0666427 47.1151 0.264102 46.9178 0.659022V8.47843C46.9572 8.55741 46.977 8.65614 46.977 8.77462C46.977 8.89309 46.9572 8.99182 46.9178 9.07081V16.8902C46.9572 16.9692 46.977 17.0679 46.977 17.1864C46.977 17.3049 46.9572 17.4036 46.9178 17.4826V25.302C46.9572 25.381 46.977 25.4797 46.977 25.5982C46.977 25.6772 46.9572 25.7759 46.9178 25.8944V33.7138C47.0362 33.8717 46.9967 34.0692 46.7993 34.3062L42.654 38.3936C42.5356 38.4726 42.4369 38.5121 42.3579 38.5121H38.5088V42.1256C38.6272 42.2835 38.5877 42.481 38.3903 42.7179L34.2451 46.8054C34.1661 46.8843 34.0674 46.9238 33.949 46.9238H25.8953C25.7374 47.0028 25.5992 47.0028 25.4808 46.9238H17.4863C17.3284 47.0028 17.1902 47.0028 17.0718 46.9238H9.07731C8.91939 47.0028 8.78122 47.0028 8.66278 46.9238H0.66832ZM5.10938 4.15523H8.60325L11.801 1.01562H5.10938V4.15523ZM42.1222 4.15523H38.6875V1.01562H45.3199L42.1222 4.15523ZM1.67578 4.15661H4.22216V1.60938L1.67578 4.15661ZM12.4517 8.30326H9.25391V4.80822L12.4517 1.60938V8.30326ZM35.1914 4.15661H37.7378V1.60938L35.1914 4.15661ZM45.9712 8.30326H42.7734V4.80822L45.9712 1.60938V8.30326ZM1.0236 5.1018V11.7364L4.22138 8.5376V5.1018H1.0236ZM8.30716 8.30041H5.10938V5.10156H8.30716V8.30041ZM34.543 5.10156V11.7362L37.7408 8.53736V5.10156H34.543ZM41.8853 8.30041H38.6875V5.10156H41.8853V8.30041ZM9.25391 9.36719V11.7367L11.6226 9.36719H9.25391ZM42.7734 11.7367V9.36719H45.2014L42.7734 11.7367ZM38.6875 12.3883H41.8853V9.36719H38.6875V12.3883ZM8.30716 12.3883H5.10938V9.36719H8.30716V12.3883ZM9.25391 16.7134H12.4517V10.0195L9.25391 13.2184V16.7134ZM45.9712 16.7134H42.7734V13.2184L45.9712 10.0195V16.7134ZM35.3711 12.389H37.7398V10.0195L35.3711 12.389ZM4.22029 12.389H1.85156L4.22029 10.0195V12.389ZM38.6875 16.7145H41.8853V13.5156H38.6875V16.7145ZM34.543 20.1503V13.5156H37.7408V16.9514L34.543 20.1503ZM5.10938 16.7145H8.30716V13.5156H5.10938V16.7145ZM1.02344 20.1464V13.5117H4.22122V16.9475L1.02344 20.1464ZM38.6875 20.8024H41.8853V17.7812H38.6875V20.8024ZM25.3643 20.9801H21.9297V17.7812H28.5621L25.3643 20.9801ZM42.7734 17.7812V20.1508L45.2014 17.7812H42.7734ZM8.30716 20.8024H5.10938V17.7812H8.30716V20.8024ZM9.25391 17.7812V20.1508L11.6226 17.7812H9.25391ZM45.9712 25.1236H42.7734V21.6285L45.9712 18.4297V25.1236ZM1.85156 20.7992H4.22029V18.4297L1.85156 20.7992ZM12.4517 25.1236H9.25391V21.6285L12.4517 18.4297V25.1236ZM35.3711 20.7992H37.7398V18.4297L35.3711 20.7992ZM20.98 20.9769H18.4336L20.98 18.4297V20.9769ZM26.0156 25.1236H29.2134V18.4297L26.0156 21.6285V25.1236ZM41.8853 25.1246H38.6875V21.9258H41.8853V25.1246ZM1.02344 21.9258V28.5604L4.22122 25.3616V21.9258H1.02344ZM8.30716 25.1246H5.10938V21.9258H8.30716V25.1246ZM17.7812 21.9258V28.5604L20.979 25.3616V21.9258H17.7812ZM25.1275 25.1246H21.9297V21.9258H25.1275V25.1246ZM34.5391 21.9258V28.5604L37.7368 25.3616V21.9258H34.5391ZM41.8853 29.2125H38.6875V26.1914H41.8853V29.2125ZM42.7734 26.1914V28.5609L45.2014 26.1914H42.7734ZM9.25391 28.5609V26.1914H11.6226L9.25391 28.5609ZM5.10938 29.2125H8.30716V26.1914H5.10938V29.2125ZM26.0156 28.5609V26.1914H28.3844L26.0156 28.5609ZM21.9297 29.2125H25.1275V26.1914H21.9297V29.2125ZM29.2134 33.4784H26.0156V30.0426L29.2134 26.8438V33.4784ZM9.25391 33.4784H12.4517V26.8438L9.25391 30.0426V33.4784ZM37.7398 29.2133H35.3711L37.7398 26.8438V29.2133ZM42.7734 33.4784H45.9712V26.8438L42.7734 30.0426V33.4784ZM4.22029 29.2133H1.85156L4.22029 26.8438V29.2133ZM18.6094 29.2133H20.9781V26.8438L18.6094 29.2133ZM25.1275 33.4755H21.9297V30.3359H25.1275V33.4755ZM17.7812 33.6533H20.979V30.3359H17.7812V33.6533ZM8.30716 33.4755H5.10938V30.3359H8.30716V33.4755ZM1.02344 30.3359V36.9706L4.22122 33.7717V30.3359H1.02344ZM41.8853 33.4755H38.6875V30.3359H41.8853V33.4755ZM34.5391 33.6533H37.7368V30.3359H34.5391V33.6533ZM42.7734 36.9691V34.4219H45.3198L42.7734 36.9691ZM38.5091 37.6207H41.8846V34.4219H38.5091L38.3945 34.5319L38.5091 37.6207ZM17.7812 36.928L17.782 34.6016H20.1507L17.7812 36.928ZM13.5195 37.8004H16.895L16.9534 37.7427L16.895 34.6016H13.5195V37.8004ZM26.0156 36.9711V34.6016H28.3844L26.0156 36.9711ZM21.9297 37.6227H25.1275V34.6016H21.9297V37.6227ZM8.30716 37.6227H5.10938V34.6016H8.30716V37.6227ZM9.25391 34.6016V36.9711L11.6226 34.6016H9.25391ZM33.6528 37.8004H30.2773V34.6016H33.6528L33.7674 37.6904L33.6528 37.8004ZM34.5398 34.6016L34.5391 36.9442L36.9678 34.6016H34.5398ZM4.22029 37.6234H1.85156L4.22029 35.2539V37.6234ZM35.1914 37.6238H37.6194V35.2812L35.1914 37.6238ZM20.8044 37.6215H18.6133L20.8044 35.4297V37.6215ZM10.0234 37.7992H12.4514V35.4297L10.0234 37.7992ZM29.2125 37.7992H26.8438L29.2125 35.4297V37.7992ZM34.4219 41.8883H37.6197V38.5117H34.4219V41.8883ZM29.2115 41.8863H26.1914V38.6875H29.2115V41.8863ZM13.5195 41.8863H16.7173V38.6875H13.5195V41.8863ZM20.8014 41.8863H17.7812V38.6875H20.8014V41.8863ZM5.10938 41.8863H8.30716V38.6875H5.10938V41.8863ZM12.4543 41.8863H9.375V38.6875H12.4543V41.8863ZM1.02344 38.6875V45.3814L4.22122 42.1825V38.6875H1.02344ZM25.1275 41.8863H21.9297V38.6875H25.1275V41.8863ZM30.2773 41.8863H33.4751V38.6875H30.2773V41.8863ZM25.1253 46.0348H18.4336L21.6314 42.8359H25.1253V46.0348ZM26.1914 42.8359V45.2055L28.5601 42.8359H26.1914ZM34.4219 45.3832V42.8359H36.9683L34.4219 45.3832ZM17.7812 42.8359V45.2055L20.15 42.8359H17.7812ZM33.4762 46.0348H26.8438L30.0415 42.8359H33.4762V46.0348ZM9.375 42.8359V45.2055L11.8029 42.8359H9.375ZM8.30822 46.0348H1.67578L4.87357 42.8359H8.30822V46.0348ZM10.0234 46.0348H16.7151V42.8359H13.2212L10.0234 46.0348Z",
    fill: "url(#paint1_linear_1_23617)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4517 8.30326H9.25391V4.80822L12.4517 1.60938V8.30326Z",
    fill: "url(#paint2_linear_1_23617)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02368 11.7365V5.10181H4.22147V8.53761L1.02368 11.7365Z",
    fill: "url(#paint3_linear_1_23617)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30716 8.30041H5.10938V5.10156H8.30716V8.30041Z",
    fill: "url(#paint4_linear_1_23617)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25391 11.7367V9.36719H11.6226L9.25391 11.7367Z",
    fill: "url(#paint5_linear_1_23617)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30716 12.3883H5.10938V9.36719H8.30716V12.3883Z",
    fill: "url(#paint6_linear_1_23617)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4517 16.7134H9.25391V13.2184L12.4517 10.0195V16.7134Z",
    fill: "url(#paint7_linear_1_23617)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22029 12.389H1.85156L4.22029 10.0195V12.389Z",
    fill: "url(#paint8_linear_1_23617)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30716 16.7145H5.10938V13.5156H8.30716V16.7145Z",
    fill: "url(#paint9_linear_1_23617)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02344 20.1464V13.5117H4.22122V16.9475L1.02344 20.1464Z",
    fill: "url(#paint10_linear_1_23617)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30716 20.8024H5.10938V17.7812H8.30716V20.8024Z",
    fill: "url(#paint11_linear_1_23617)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25391 20.1508V17.7812H11.6226L9.25391 20.1508Z",
    fill: "url(#paint12_linear_1_23617)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22029 20.7992H1.85156L4.22029 18.4297V20.7992Z",
    fill: "url(#paint13_linear_1_23617)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4517 25.1236H9.25391V21.6285L12.4517 18.4297V25.1236Z",
    fill: "url(#paint14_linear_1_23617)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02344 28.5604V21.9258H4.22122V25.3616L1.02344 28.5604Z",
    fill: "url(#paint15_linear_1_23617)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30716 25.1246H5.10938V21.9258H8.30716V25.1246Z",
    fill: "url(#paint16_linear_1_23617)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25391 28.5609V26.1914H11.6226L9.25391 28.5609Z",
    fill: "url(#paint17_linear_1_23617)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30716 29.2125H5.10938V26.1914H8.30716V29.2125Z",
    fill: "url(#paint18_linear_1_23617)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4517 33.4784H9.25391V30.0426L12.4517 26.8438V33.4784Z",
    fill: "url(#paint19_linear_1_23617)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22029 29.2133H1.85156L4.22029 26.8438V29.2133Z",
    fill: "url(#paint20_linear_1_23617)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30716 33.4755H5.10938V30.3359H8.30716V33.4755Z",
    fill: "url(#paint21_linear_1_23617)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02344 36.9706V30.3359H4.22122V33.7717L1.02344 36.9706Z",
    fill: "url(#paint22_linear_1_23617)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7812 36.928L17.782 34.6016H20.1507L17.7812 36.928Z",
    fill: "url(#paint23_linear_1_23617)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.895 37.8004H13.5195V34.6016H16.895L16.9534 37.7427L16.895 37.8004Z",
    fill: "url(#paint24_linear_1_23617)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0156 36.9711V34.6016H28.3844L26.0156 36.9711Z",
    fill: "url(#paint25_linear_1_23617)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1275 37.6227H21.9297V34.6016H25.1275V37.6227Z",
    fill: "url(#paint26_linear_1_23617)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30716 37.6227H5.10938V34.6016H8.30716V37.6227Z",
    fill: "url(#paint27_linear_1_23617)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25391 36.9711V34.6016H11.6226L9.25391 36.9711Z",
    fill: "url(#paint28_linear_1_23617)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6528 37.8004H30.2773V34.6016H33.6528L33.7674 37.6904L33.6528 37.8004Z",
    fill: "url(#paint29_linear_1_23617)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5391 36.9442L34.5398 34.6016H36.9678L34.5391 36.9442Z",
    fill: "url(#paint30_linear_1_23617)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22029 37.6234H1.85156L4.22029 35.2539V37.6234Z",
    fill: "url(#paint31_linear_1_23617)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6194 37.6238H35.1914L37.6194 35.2812V37.6238Z",
    fill: "url(#paint32_linear_1_23617)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8044 37.6215H18.6133L20.8044 35.4297V37.6215Z",
    fill: "url(#paint33_linear_1_23617)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4514 37.7992H10.0234L12.4514 35.4297V37.7992Z",
    fill: "url(#paint34_linear_1_23617)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2125 37.7992H26.8438L29.2125 35.4297V37.7992Z",
    fill: "url(#paint35_linear_1_23617)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6197 41.8883H34.4219V38.5117H37.6197V41.8883Z",
    fill: "url(#paint36_linear_1_23617)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2115 41.8863H26.1914V38.6875H29.2115V41.8863Z",
    fill: "url(#paint37_linear_1_23617)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7173 41.8863H13.5195V38.6875H16.7173V41.8863Z",
    fill: "url(#paint38_linear_1_23617)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8014 41.8863H17.7812V38.6875H20.8014V41.8863Z",
    fill: "url(#paint39_linear_1_23617)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30716 41.8863H5.10938V38.6875H8.30716V41.8863Z",
    fill: "url(#paint40_linear_1_23617)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4543 41.8863H9.375V38.6875H12.4543V41.8863Z",
    fill: "url(#paint41_linear_1_23617)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02344 45.3814V38.6875H4.22122V42.1825L1.02344 45.3814Z",
    fill: "url(#paint42_linear_1_23617)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1275 41.8863H21.9297V38.6875H25.1275V41.8863Z",
    fill: "url(#paint43_linear_1_23617)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4751 41.8863H30.2773V38.6875H33.4751V41.8863Z",
    fill: "url(#paint44_linear_1_23617)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1253 46.0348H18.4336L21.6314 42.8359H25.1253V46.0348Z",
    fill: "url(#paint45_linear_1_23617)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1914 45.2055V42.8359H28.5601L26.1914 45.2055Z",
    fill: "url(#paint46_linear_1_23617)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4219 45.3832V42.8359H36.9683L34.4219 45.3832Z",
    fill: "url(#paint47_linear_1_23617)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7812 45.2055V42.8359H20.15L17.7812 45.2055Z",
    fill: "url(#paint48_linear_1_23617)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4762 46.0348H26.8438L30.0415 42.8359H33.4762V46.0348Z",
    fill: "url(#paint49_linear_1_23617)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 45.2055V42.8359H11.8029L9.375 45.2055Z",
    fill: "url(#paint50_linear_1_23617)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30822 46.0348H1.67578L4.87357 42.8359H8.30822V46.0348Z",
    fill: "url(#paint51_linear_1_23617)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7151 46.0348H10.0234L13.2212 42.8359H16.7151V46.0348Z",
    fill: "url(#paint52_linear_1_23617)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60325 4.15523H5.10938V1.01562H11.801L8.60325 4.15523Z",
    fill: "url(#paint53_linear_1_23617)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22216 4.15661H1.67578L4.22216 1.60938V4.15661Z",
    fill: "url(#paint54_linear_1_23617)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_23617",
    x1: 70.4976,
    y1: 16.4528,
    x2: 69.2622,
    y2: 32.4897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_23617",
    x1: 23.5,
    y1: 70.5,
    x2: 70.5,
    y2: 23.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0522DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842456,
    stopColor: "#8E67F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E326FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_23617",
    x1: 10.2047,
    y1: 0.614222,
    x2: 6.93625,
    y2: 5.86559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_23617",
    x1: 1.97449,
    y1: 4.11546,
    x2: -1.25226,
    y2: 9.34609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_23617",
    x1: 6.06018,
    y1: 4.626,
    x2: 5.10879,
    y2: 7.82468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_23617",
    x1: 9.95821,
    y1: 9.01492,
    x2: 9.25348,
    y2: 11.3843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_23617",
    x1: 6.06018,
    y1: 8.91805,
    x2: 5.20405,
    y2: 11.9658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_23617",
    x1: 10.2047,
    y1: 9.02438,
    x2: 6.93625,
    y2: 14.2757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_23617",
    x1: 2.55586,
    y1: 9.66726,
    x2: 1.85113,
    y2: 12.0367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_23617",
    x1: 6.06018,
    y1: 13.0401,
    x2: 5.10879,
    y2: 16.2387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_23617",
    x1: 1.97424,
    y1: 12.5254,
    x2: -1.2525,
    y2: 17.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_23617",
    x1: 6.06018,
    y1: 17.3321,
    x2: 5.20405,
    y2: 20.3798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_23617",
    x1: 9.95821,
    y1: 17.429,
    x2: 9.25348,
    y2: 19.7984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_23617",
    x1: 2.55586,
    y1: 18.0774,
    x2: 1.85113,
    y2: 20.4468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_23617",
    x1: 10.2047,
    y1: 17.4345,
    x2: 6.93625,
    y2: 22.6859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_23617",
    x1: 1.97424,
    y1: 20.9394,
    x2: -1.2525,
    y2: 26.1701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_23617",
    x1: 6.06018,
    y1: 21.4502,
    x2: 5.10879,
    y2: 24.6489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_23617",
    x1: 9.95821,
    y1: 25.8391,
    x2: 9.25348,
    y2: 28.2085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_23617",
    x1: 6.06018,
    y1: 25.7423,
    x2: 5.20405,
    y2: 28.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_23617",
    x1: 10.2047,
    y1: 25.8574,
    x2: 6.97797,
    y2: 31.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_23617",
    x1: 2.55586,
    y1: 26.4915,
    x2: 1.85113,
    y2: 28.8609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_23617",
    x1: 6.06018,
    y1: 29.8692,
    x2: 5.14096,
    y2: 33.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_23617",
    x1: 1.97424,
    y1: 29.3496,
    x2: -1.2525,
    y2: 34.5802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_23617",
    x1: 18.4858,
    y1: 34.2557,
    x2: 17.8046,
    y2: 36.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_23617",
    x1: 14.5405,
    y1: 34.126,
    x2: 13.6449,
    y2: 37.3596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_23617",
    x1: 26.7199,
    y1: 34.2493,
    x2: 26.0152,
    y2: 36.6187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_23617",
    x1: 22.8805,
    y1: 34.1524,
    x2: 22.0244,
    y2: 37.2002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1_23617",
    x1: 6.06018,
    y1: 34.1524,
    x2: 5.20405,
    y2: 37.2002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1_23617",
    x1: 9.95821,
    y1: 34.2493,
    x2: 9.25348,
    y2: 36.6187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_23617",
    x1: 31.315,
    y1: 34.126,
    x2: 30.4318,
    y2: 37.3669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1_23617",
    x1: 35.2612,
    y1: 34.2533,
    x2: 34.5855,
    y2: 36.6092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1_23617",
    x1: 2.55586,
    y1: 34.9016,
    x2: 1.85113,
    y2: 37.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1_23617",
    x1: 35.9133,
    y1: 34.933,
    x2: 35.2375,
    y2: 37.2888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1_23617",
    x1: 19.2648,
    y1: 35.1038,
    x2: 18.6129,
    y2: 37.2955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1_23617",
    x1: 10.7453,
    y1: 35.0774,
    x2: 10.0551,
    y2: 37.4561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1_23617",
    x1: 27.548,
    y1: 35.0774,
    x2: 26.8433,
    y2: 37.4468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1_23617",
    x1: 35.3727,
    y1: 38.0097,
    x2: 34.3224,
    y2: 41.3551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1_23617",
    x1: 27.0894,
    y1: 38.2119,
    x2: 26.0919,
    y2: 41.3794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1_23617",
    x1: 14.4703,
    y1: 38.2119,
    x2: 13.519,
    y2: 41.4106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1_23617",
    x1: 18.6792,
    y1: 38.2119,
    x2: 17.6817,
    y2: 41.3794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1_23617",
    x1: 6.06018,
    y1: 38.2119,
    x2: 5.10879,
    y2: 41.4106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1_23617",
    x1: 10.2906,
    y1: 38.2119,
    x2: 9.30887,
    y2: 41.3904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1_23617",
    x1: 1.97424,
    y1: 37.6923,
    x2: -1.29422,
    y2: 42.9437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1_23617",
    x1: 22.8805,
    y1: 38.2119,
    x2: 21.9291,
    y2: 41.4106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1_23617",
    x1: 31.2281,
    y1: 38.2119,
    x2: 30.2768,
    y2: 41.4106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1_23617",
    x1: 20.4232,
    y1: 42.3604,
    x2: 19.9382,
    y2: 45.7731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1_23617",
    x1: 26.8957,
    y1: 42.4837,
    x2: 26.191,
    y2: 44.8531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1_23617",
    x1: 35.179,
    y1: 42.4573,
    x2: 34.4214,
    y2: 45.0043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1_23617",
    x1: 18.4855,
    y1: 42.4837,
    x2: 17.7808,
    y2: 44.8531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1_23617",
    x1: 28.8158,
    y1: 42.3604,
    x2: 28.3266,
    y2: 45.7719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1_23617",
    x1: 10.0969,
    y1: 42.4837,
    x2: 9.40666,
    y2: 44.8624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1_23617",
    x1: 3.64782,
    y1: 42.3604,
    x2: 3.1586,
    y2: 45.7719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1_23617",
    x1: 12.0131,
    y1: 42.3604,
    x2: 11.528,
    y2: 45.7731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1_23617",
    x1: 7.09902,
    y1: 0.548872,
    x2: 6.63141,
    y2: 3.90081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1_23617",
    x1: 2.4329,
    y1: 1.23069,
    x2: 1.67532,
    y2: 3.77778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWattlordLogo);
export default __webpack_public_path__ + "res/media/wattlord-logo.b3cda15229dae3786f62f9fb30c5384c.svg";
export { ForwardRef as ReactComponent };